export default {
  /** 原料入库-获取分页查询列表 */
  LIST_MATERIALSINSTOCK_BY_PAGE: '/produce/pdMaterialsInboundDetail/queryList',
  /** 原料入库-批量导入 */
  LIST_MATERIALSINSTOCK_IMPORT: '/produce/pdMaterialsInboundDetail/importExcel',
  /** 原料入库-批量导出 */
  LIST_MATERIALSINSTOCK_EXPORT: '/produce/pdMaterialsInboundDetail/exportExcel',
  /** 原料入库-批量删除 */
  LIST_MATERIALSINSTOCK_DELETE: '/produce/pdMaterialsInboundDetail/delete',
};
